import React, { memo, useEffect, useState } from 'react'
import { Alert } from '@mui/material'

import {
  ALERT_DISAPPEAR_TIME,
  INFO_ALERT_DISAPPEAR_TIME
} from '../../../constants/app'

const CustomAlert = ({ error, info, success, onTimeOut, ...restProps }) => {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    if (error || success) {
      const timer = setTimeout(() => {
        setVisible(false)
      }, ALERT_DISAPPEAR_TIME)
      return () => clearTimeout(timer)
    }
  }, [error, success])

  useEffect(() => {
    if (info && onTimeOut) {
      const timer = setTimeout(() => {
        setVisible(false)
        onTimeOut()
      }, INFO_ALERT_DISAPPEAR_TIME)
      return () => clearTimeout(timer)
    }
  }, [info, onTimeOut])

  const getAlertProps = () => {
    if (error) return { severity: 'error', label: error }
    if (success) return { severity: 'success', label: success }
    if (info) return { severity: 'info', label: info }
    return null
  }

  const alertProps = getAlertProps()

  if (!alertProps || !visible) return null

  return (
    <Alert variant='filled' severity={alertProps.severity} {...restProps}>
      {alertProps.label}
    </Alert>
  )
}

export default memo(CustomAlert)
